
let currentImages = [];
let currentIndex = 0;
let intervalId = null;
const hoverContainer = document.querySelector('.hover-preview-events');
function updatePreviewPosition(event) {
  hoverContainer.style.left = `${event.clientX + 20}px`;
  hoverContainer.style.top = `${event.clientY + 20}px`;
}

function showNextImage() {
  if (!currentImages.length) return;
  hoverContainer.querySelectorAll('img').forEach((img, index) => {
    img.style.opacity = index === currentIndex ? 1 : 0;
  });

  currentIndex = (currentIndex + 1) % currentImages.length;
}
function clearHoverPreview() {
  hoverContainer.innerHTML = '';
  hoverContainer.style.display = 'none';
  currentImages = [];
  clearInterval(intervalId);
  intervalId = null;
}
document.querySelectorAll('.events__item').forEach(item => {
  item.addEventListener('mouseenter', function () {
    const imagesString = item.getAttribute('data-images');
    currentImages = imagesString
      .split(',')
      .map(img => img.trim())
      .filter(img => img)
      .map(img => (img.startsWith('http') ? img : `https:${img}`));

    if (!currentImages.length) return;
    hoverContainer.innerHTML = '';
    currentImages.forEach((imageUrl, index) => {
      const imgElement = document.createElement('img');
      imgElement.src = imageUrl;
      imgElement.alt = 'Event image';
      imgElement.style.position = 'absolute';
      imgElement.style.zIndex = '1';
      imgElement.style.opacity = index === 0 ? 1 : 0;
      // imgElement.style.transition = 'opacity 0.3s ease-in';
      hoverContainer.appendChild(imgElement);
    });

    hoverContainer.style.display = 'block';
    currentIndex = 0;

    showNextImage();
    if (!intervalId) {
      intervalId = setInterval(showNextImage, 500);
    }
  });

  item.addEventListener('mousemove', updatePreviewPosition);

  item.addEventListener('mouseleave', clearHoverPreview);
});
let scrollTimeout;
window.addEventListener('scroll', () => {
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(() => {
    if (hoverContainer.style.display === 'block') {
      clearHoverPreview();
    }
  }, 50);
});
